import React from 'react';

const SingleInput = ({ onPress }) => {
  return (
    <div className="text-center px-md-3 py-3">
      <div className="fs-6 fw-bold text-grey">Tambah Data Vendor</div>
      <div className="fs-8 text-grey ">
        Anda dapat menambahkan data vendor dengan mengisi form data vendor
      </div>

      <div className="d-block mt-3">
        <div
          className="btn btn-sm btn-primary rounded-2 px-3"
          onClick={onPress}
        >
          Tambah Data Vendor
        </div>
      </div>
    </div>
  );
};

export default SingleInput;
